class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.radios = this.querySelectorAll('input[name="collections-tab"]');
    this.collectionLists = this.querySelectorAll('.collection-list');

    this.radios.forEach((radio) => {
      radio.addEventListener('change', this.changeTab.bind(this));
    });

    this.changeTab();
  }

  changeTab() {
    let selected;
    for (const radio of this.radios) {
      if (radio.checked) {
        selected = radio.getAttribute('value');
        break;
      }
    }

    for (const collectionList of this.collectionLists) {
      if (collectionList.dataset.collectionsTab === selected) collectionList.style.display = '';
      else collectionList.style.display = 'none';
    }
  }
}

customElements.define('collection-tabs', CollectionTabs);
